import { useContext } from 'react';
import { SchedulerInquiryContext } from '../providers/SchedulerInquiryContext/SchedulerInquiryContext';
import { Inquiry } from '../components/SchedulerInquiry/SchedulerInquiry.types';

const useSchedulerInquiryContext = (): Inquiry | undefined => {
  return useContext(SchedulerInquiryContext);
};

export default useSchedulerInquiryContext;
